<template>
  <div class="alert-off-peak-warning custom px-8">
    <div class="d-flex align-items-center justify-content-center m-auto">
      <div class="icon custom pe-2">
        <img src="~@shared-images/icons/alert/warning-rectangle.svg" alt="warning" />
      </div>
      <span class="fs-13-px fw-semibold"
        >Requests submitted during late evenings or weekends may be processed slower than usual.</span
      >
    </div>
  </div>
</template>
